import { I18NextPipe } from 'angular-i18next';
import { TableHeader } from 'mbs-ui-kit';

export const tableHeaders = (i18n?: I18NextPipe): TableHeader[] => [
  {
    name: i18n.transform('shared:unable-emails-modal.table.columns.email'),
    gridColSize: '3fr',
  },
  {
    name: i18n.transform('shared:unable-emails-modal.table.columns.reason'),
    gridColSize: '5fr',
  },
  {
    name: '',
    gridColSize: '1fr',
    class: '-end'
  },
];
